module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Beach/Tokyo_Beach_HadGEM2_RCP26_Now.png";